import { setAxiosBaseURL } from '../axios-instance';

export interface RuntimeConfig {
  API_BASE_URL: string;
  FEDLOGIN_URL: string;
}

let runtimeConfig: RuntimeConfig | null = null;

export const loadRuntimeConfig = async (): Promise<RuntimeConfig> => {
  if (runtimeConfig) {
    return runtimeConfig;
  }

  const staticConfig: RuntimeConfig = {
    API_BASE_URL: '',
    FEDLOGIN_URL: '',
  };

  try {
    const response = await fetch('/static.json');
    if (response.ok) {
      const dynamicConfig = await response.json();
      runtimeConfig = {
        ...staticConfig,
        API_BASE_URL: dynamicConfig.API_BASE_URL || '',
        FEDLOGIN_URL: dynamicConfig.FEDLOGIN_URL || ''
      };
      console.log('Loaded API config from static.json');
    } else {
      throw new Error('static.json not found');
    }
  } catch (error) {
    console.error('Failed to load static.json, using relative API URLs');
    runtimeConfig = staticConfig;
  }
  if (runtimeConfig?.API_BASE_URL) {
    setAxiosBaseURL(runtimeConfig.API_BASE_URL);
  }

  return runtimeConfig as RuntimeConfig;
};

export const getRuntimeConfig = (): RuntimeConfig | null => runtimeConfig;

export const getApiBaseUrl = (): string => runtimeConfig?.API_BASE_URL || '';

export const getFedLoginUrl = (): string => runtimeConfig?.FEDLOGIN_URL || process.env.REACT_APP_FEDLOGIN_URL || '';
